import { E_AlarmLevel2, E_AlarmType } from '@/api/enums'
import { isFailedAndReport } from '@/api/helper'
import { alarmRecordAutoRead } from '@/api/moudules/alarm'
import { getAlarmColor } from '@/utils/alarm'
import { withDialogLoading } from '@/utils/task'
import { globalBuildAlarmHistoryRouter } from '@/view_helper/alarmCenterHelper'
import { IAlarmDetailEx, exAlarmDetail } from '@/view_helper/fault'
import _ from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'

function makeQueryForm() {
    return {
        pageNum: 1,
        pageSize: 10,
    }
}

@Component({
    name: 'AlarmPopupList'
})
export class AlarmPopupListImpl extends Vue {
    data: IAlarmDetailEx[] = []
    pageTotal = 0

    onClose() {
        this.$emit('close')
    }

    queryForm = makeQueryForm()

    // 获取报警颜色
    getAlarmColor(alarmLevel: E_AlarmLevel2) {
        return getAlarmColor(alarmLevel);
    }

    onQuery() {
        const buildTask = async () => {
            const {
                pageNum,
                pageSize,
            } = this.queryForm
            const res = await this.$api.alarm.popupList({
                pageNum,
                pageSize,
            })
            if (isFailedAndReport(this, res)) {
                this.pageTotal = 0
                this.data = []
                return
            }
            this.pageTotal = res.data.total
            this.data = _.map(res.data.records as any, exAlarmDetail)
        }
        withDialogLoading(this, buildTask())
    }

    onReset() {
        this.queryForm = makeQueryForm()
        this.onQuery()
    }

    handleSizeChange(val: number) {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = val
        this.onQuery()
    }

    handleCurrentChange(val: number) {
        this.queryForm.pageNum = val
        this.onQuery()
    }

    onView(row) {
        const {
            companyId,
            areaId,
            equipmentId,
            mappingId,
            id,
            alarmType
        } = row
        this.$api.alarm.alarmRecordRead({
            ids: [id]
        })
        const params = {
            companyId,
            areaId,
            equipmentId,
            mappingId,
        }
        let routeTo = globalBuildAlarmHistoryRouter(alarmType, params)        
        const res = this.$router.resolve(routeTo as any)
        var url = new URL(location.href)
        url.searchParams.append('delayFetchAlaramCount', '1')
        url.hash = res.href
        window.open(url.href, '_blank')
        this.onReset()
        // this.$emit('close')
    }

    get CanMarkRead() {
        return !_.isEmpty(this.data)
    }

    onRead() {
        const ids = _.map(this.data, d => d.id)
        const task = this.$api.alarm.alarmRecordRead({
            ids
        }).then(res => {
            if (isFailedAndReport(this, res)) {
                return
            }
            this.$message({
                type: 'success',
                message: this.$t('alarm.markHasReadedSuccess') as string,
            })
            this.onReset()
        })
        withDialogLoading(this, task)
    }

    onReadAll() {
        const task = alarmRecordAutoRead().then(res => {
            if (isFailedAndReport(this, res)) {
                return
            }
            this.$message({
                type: 'success',
                message: this.$t('alarm.markHasReadedSuccess') as string,
            })
            this.onReset()
        })
        withDialogLoading(this, task)
    }
    mounted() {
        this.onQuery()
    }
}
